import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';

export type StatementType = 'PL' | 'BS';

export type AccStatementLine = {
  id: number;
  statementType: StatementType;
  accountId: number;
  label: string | null;
  sortOrder: number;
  sign: number;
  account?: { id: number; combLevel: string; name: string; parentId: number | null };
};

export const useAccStatementLines = (statementType: StatementType) => {
  const url = `/acc-statement-lines?statementType=${statementType}`;
  const { data, error, isLoading, mutate } = useSWR<AccStatementLine[]>(url, fetcher);
  return { data: data ?? [], isLoading, isError: error, mutate };
};

export type AccAccountOption = {
  id: number;
  combLevel: string;
  name: string;
  parentId: number | null;
};

export const useAccAccountsForMapping = () => {
  const url = '/acc-accounts';
  const { data, isLoading } = useSWR<AccAccountOption[] | { data: AccAccountOption[] }>(url, fetcher);
  const rows = Array.isArray(data) ? data : data?.data ?? [];
  return { accounts: rows, isLoading };
};
